import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteRoute } from '../../../../actions';

const RouteDeleteButton = ({ dispatchDeleteRoute, routeId, disabled }) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteRoute({ routeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

RouteDeleteButton.propTypes = {
  dispatchDeleteRoute: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  routeId: PropTypes.number.isRequired,
};

RouteDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteRoute: deleteRoute,
};

export default connect(null, mapDispatchToProps)(RouteDeleteButton);
